module.exports = __webpack_public_path__ + "static/media/MyTicketsDropdown.12167beb.svg";